<template>
    <form autocomplete="off" class="">
        <div class="row gy-3">
            <div class="col-12">
                <label class="form-label">Course category <span class="text-danger">*</span></label>
                <select v-model="data.category"
                    class="form-select" :class="{ 'is-invalid': v$.data.category.$error }">
                    <option disabled value="">--select--</option>
                    <option v-for="(option, uIndex) in courseTypes" :key="uIndex"
                        :value="option.title">{{ option.title }}</option>
                </select>

                <div v-for="(item, index) in v$.data.category.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <label class="form-label">Course name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="data.course_name"
                :class="{ 'is-invalid': v$.data.course_name.$error }"  placeholder="Course name" />
                <div v-for="(item, index) in v$.data.course_name.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <div class="d-flex mt-3 justify-content-end">
                    <b-button variant="primary" 
                    @click.prevent="create()"
                     type="button">Submit</b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props:{
        courseTypes:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            isLoading: false,
            data: {
                category: "",
                course_name: "",
            },
        }
    },
    validations() {
        return {        
            data:{
                category: {
                    required: helpers.withMessage("Category is required", required),
                },
                course_name: {
                    required: helpers.withMessage("Course name is required", required),
                },
            },
        }
    },
    methods:{
        create() {
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    type: "course_request",
                    title: "Course Creation Request",
                    content: `Add '${this.data.course_name}' course under '${this.data.category}' category`
                }))

                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post('/notifications/create', formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.resetForm();

                        Swal.fire({
                            icon: 'success',
                            title: "Your request has been submitted!",
                            html: "You can check back to proceed. If it’s still not available after 24 hours, please contact support at 0201 229 1111.",
                            confirmButtonText: "Okay",
                        })
                    }
                })
            })
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
    },
}
</script>